// v3/design-system/primitives/input.tsx — Input primitive
// Shadcn/UI pattern: forwardRef, cn() merging, 44px touch target.
// Zero imports from v1/v2.

import * as React from 'react';

import { cn } from '../utils';

const Input = React.forwardRef<HTMLInputElement, React.ComponentProps<'input'>>(
  ({ className, type, ...props }, ref) => {
    return (
      <input
        type={type}
        className={cn(
          // Meridian control: --shape-control radius, quiet hover (border darkens),
          // compact on desktop, 44px touch target kept on phone.
          'flex h-11 min-h-[44px] w-full rounded-[var(--shape-control)] border border-input bg-card px-3 py-2 text-base ring-offset-background transition-[border-color,box-shadow] duration-fast file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground hover:border-[var(--m-muted)] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50 md:h-9 md:min-h-0 md:text-sm',
          props['aria-invalid'] && 'border-[var(--ch-danger-fg)] focus-visible:ring-[var(--ch-danger-fg)]',
          className,
        )}
        ref={ref}
        {...props}
      />
    );
  },
);
Input.displayName = 'Input';

export { Input };
